export default __webpack_public_path__ + "static/media/portfolio_01.19dcd772.png";